import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { SECTIONS, monthRows, cellValue, summaryHeader, summaryRow, periodTotals, fmtMoney } from './leaseHistoryConfig';

const BRAND = [22, 163, 74];
const safeName = (s) => s.replace(/[^\w.-]+/g, '_');

const totalsRow = (months) => {
  const t = periodTotals(months);
  return ['TOTAL (period)', `${t.possession} distinct`, t.opening, t.handovers, t.takeovers, t.closing, '-',
    t.fines, t.finesAmount, t.salik, t.salikAmount, t.maintenance, t.maintenanceAmount];
};

const fmtSummaryForPdf = (row) => row.map((v, i) => ([8, 10, 12].includes(i) ? fmtMoney(v) : v));

const sectionSheetRows = (months, key) => {
  const cols = SECTIONS[key].columns;
  const rows = [];
  months.forEach((m) => monthRows(m, key).forEach((r) => {
    rows.push([m.month_label, ...cols.map((c) => cellValue(r, c))]);
  }));
  return [['Month', ...cols.map((c) => c[1])], ...rows];
};

export const exportExcel = (report, months, label) => {
  const wb = XLSX.utils.book_new();
  const head = [
    ['Lease History Report'], ['Lessee', report.lessee.name],
    ['Period', `${months[0].window_start} to ${months[months.length - 1].window_end}`], [],
    summaryHeader, ...months.map(summaryRow),
  ];
  if (months.length > 1) head.push(totalsRow(months));
  const ws = XLSX.utils.aoa_to_sheet(head);
  ws['!cols'] = summaryHeader.map((h, i) => ({ wch: i === 0 ? 16 : 12 }));
  XLSX.utils.book_append_sheet(wb, ws, 'Summary');
  Object.keys(SECTIONS).forEach((key) => {
    const data = sectionSheetRows(months, key);
    if (data.length > 1) {
      const sh = XLSX.utils.aoa_to_sheet(data);
      sh['!cols'] = data[0].map(() => ({ wch: 18 }));
      XLSX.utils.book_append_sheet(wb, sh, SECTIONS[key].title.slice(0, 31));
    }
  });
  XLSX.writeFile(wb, `LeaseHistory_${safeName(`${report.lessee.name}_${label}`)}.xlsx`);
};

export const exportPdf = (report, months, label) => {
  const doc = new jsPDF({ orientation: 'landscape' });
  const pageTitle = (text) => {
    doc.setFontSize(13);
    doc.setTextColor(15, 23, 42);
    doc.text(text, 14, 14);
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text(`${report.lessee.name}  |  ${months[0].window_start} to ${months[months.length - 1].window_end}`, 14, 20);
  };
  pageTitle('Lease History - Summary');
  const body = months.map((m) => fmtSummaryForPdf(summaryRow(m)));
  if (months.length > 1) body.push(fmtSummaryForPdf(totalsRow(months)));
  autoTable(doc, {
    startY: 26, head: [summaryHeader], body, theme: 'grid',
    headStyles: { fillColor: BRAND, fontSize: 8 }, styles: { fontSize: 8 },
    didParseCell: (d) => { if (months.length > 1 && d.section === 'body' && d.row.index === body.length - 1) d.cell.styles.fontStyle = 'bold'; },
  });
  doc.setFontSize(8);
  doc.setTextColor(100, 116, 139);
  doc.text('Start + HO - TO = End. Only permanent takeovers reduce the count. "In possession" = every bike held at any time in the month.', 14, doc.lastAutoTable.finalY + 6);

  months.forEach((m) => {
    doc.addPage();
    pageTitle(`${m.month_label} - details`);
    let y = 26;
    Object.entries(SECTIONS).forEach(([key, sec]) => {
      const rows = monthRows(m, key);
      if (!rows.length) return;
      const total = sec.amountKey ? `  |  AED ${fmtMoney(rows.reduce((a, r) => a + Number(r[sec.amountKey] || 0), 0))}` : '';
      if (y > 180) { doc.addPage(); pageTitle(`${m.month_label} - details (cont.)`); y = 26; }
      doc.setFontSize(10);
      doc.setTextColor(15, 23, 42);
      doc.text(`${sec.title} (${rows.length})${total}`, 14, y);
      autoTable(doc, {
        startY: y + 2, head: [sec.columns.map((c) => c[1])],
        body: rows.map((r) => sec.columns.map((c) => cellValue(r, c))),
        theme: 'striped', headStyles: { fillColor: [71, 85, 105], fontSize: 8 }, styles: { fontSize: 7.5 },
      });
      y = doc.lastAutoTable.finalY + 8;
    });
  });
  doc.save(`LeaseHistory_${safeName(`${report.lessee.name}_${label}`)}.pdf`);
};
